import { useForm } from "react-hook-form";
import InvalidFeedback from "../../components/invalid-feedback/invalid-feedback.component";
import { SystemUserService } from "../../services/system-user";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";

function CreatePasswordPage() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const [errorMsg, setErrorMsg] = useState("");
  const [isChanged, setIsChanged] = useState(false);

  const defaultValues = {
    password: "",
    confirm_password: "",
  };

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting, isValid },
  } = useForm<typeof defaultValues>({
    mode: "onChange",
    defaultValues,
  });

  const password = watch("password");
  const confirm_password = watch("confirm_password");

  const submit = async () => {
    try {
      await SystemUserService.changePassword(
        searchParams.get("user")!,
        password,
        searchParams.get("token")!
      );
      setIsChanged(true);
    } catch (error: any) {
      setErrorMsg(error);
    }
  };

  return (
    <div className="d-flex flex-column flex-root">
      <div className="d-flex flex-column flex-lg-row flex-column-fluid">
        <div className="d-flex flex-column flex-lg-row-fluid py-10">
          <div className="d-flex flex-center flex-column flex-column-fluid">
            <div className="w-lg-500px p-10 p-lg-15 mx-auto">
              <div className="form w-100">
                {isChanged ? (
                  <div className="text-center">
                    <img
                      alt="Aguacatecnia"
                      className="h-100px mb-7"
                      src="/assets/media/logos/logo-default.svg"
                    />
                    <h1 className="text-gray-900 mb-3">
                      Contraseña creada exitosamente.
                    </h1>
                    <div className="text-gray-500 fw-semibold fs-4 mb-5">
                      Ahora puedes iniciar sesión con tu nueva contraseña
                    </div>
                    <button
                      className="btn btn-lg btn-primary w-100 mb-5"
                      onClick={() => navigate("/auth/login")}
                    >
                      <span className="indicator-label">Iniciar sesión</span>
                    </button>
                  </div>
                ) : (
                  <>
                    <div className="text-center mb-10">
                      <img
                        alt="Aguacatecnia"
                        className="h-100px mb-7"
                        src="/assets/media/logos/logo-default.svg"
                      />
                      <h1 className="text-gray-900 mb-3">
                        {searchParams.get("new") === "1" ? "Establecer contraseña" : "Reestablecer contraseña"}
                      </h1>
                      <div className="text-gray-500 fw-semibold fs-4">
                        {searchParams.get("new") === "1"
                          ? "Para acceder a la plataforma, necesitas crear una contraseña. Asegúrate de que cumpla con las siguientes reglas:"
                          : "Ingresa tu nueva contraseña."}
                      </div>
                    </div>

                    {errorMsg && (
                      <div className="alert alert-danger mb-7">{errorMsg}</div>
                    )}

                    <div className="fv-row">
                      <div className="d-flex flex-stack mb-2">
                        <label className="form-label fw-bold text-gray-900 fs-6 mb-0">
                          Contraseña
                        </label>
                      </div>
                      <input
                        className={`form-control form-control-lg form-control-solid ${
                          errors.password ? "is-invalid" : ""
                        }`}
                        type="password"
                        {...register("password", { required: true })}
                      />
                      <InvalidFeedback error={errors.password} />
                    </div>

                    <div className="card my-10">
                      <div className="card-body">
                        <p>
                          <b>Contraseña segura</b>
                        </p>
                        <p>Debe incluir almenos:</p>
                        <ul>
                          <li
                            className={`${
                              password.length >= 8
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            Mínimo 8 caracteres
                          </li>
                          <li
                            className={`${
                              /\d/.test(password)
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            1 número
                          </li>
                          <li
                            className={`${
                              /[A-Z]/.test(password)
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            1 letra mayúscula
                          </li>
                          <li
                            className={`${
                              /[$%&#!]/.test(password)
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            1 caracter especial ($,%,&,#,!)
                          </li>
                          <li
                            className={`${
                              password.length >= 8 &&
                              password === confirm_password
                                ? "text-success"
                                : "text-danger"
                            }`}
                          >
                            Nueva contraseña y repetir contraseña deben
                            coincidir
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="fv-row mb-10">
                      <div className="d-flex flex-stack mb-2">
                        <label className="form-label fw-bold text-gray-900 fs-6 mb-0">
                          Repetir Contraseña
                        </label>
                      </div>
                      <input
                        className={`form-control form-control-lg form-control-solid ${
                          errors.confirm_password ? "is-invalid" : ""
                        }`}
                        type="password"
                        {...register("confirm_password", { required: true })}
                      />
                      <InvalidFeedback error={errors.confirm_password} />
                    </div>

                    <div className="text-center">
                      <button
                        className="btn btn-lg btn-primary w-100 mb-5"
                        disabled={
                          !(
                            password.length >= 8 &&
                            /\d/.test(password) &&
                            /[A-Z]/.test(password) &&
                            /[$%&#!]/.test(password) &&
                            password.length >= 8 &&
                            password === confirm_password
                          ) || isSubmitting
                        }
                        onClick={handleSubmit(submit)}
                      >
                        {isSubmitting ? (
                          <span className="indicator-progress d-block">
                            Espere por favor...
                            <span className="spinner-border spinner-border-sm align-middle ms-2" />
                          </span>
                        ) : (
                          <span className="indicator-label">
                            {searchParams.get("new") === "1" ? "Establecer contraseña" : "Reestablecer contraseña"}
                          </span>
                        )}
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreatePasswordPage;
